import { MapDrawingConfig, drawSelectedRect } from "../canvas-drawing";

import { rectWithPadding } from "../rect-utils";
import { SnapLine } from "../rect-snapping";
import { MapElement } from "../canvas-drawing";
import { Coordinate } from "PosterEditor/hooks/use-coordinates";
import { Rect } from "PosterEditor/model/poster-types";
import { GPSSource } from "PosterEditor/model/poster-project";

export interface DrawDataConfig {
  ctx: any;
  rect: Rect;
  gpsSource: GPSSource;
  color: string;
}

export const drawData = ({
  ctx,
  rect,
  gpsSource,
  color,
}: DrawDataConfig): {
  elementUnderPointerLocation: MapElement | undefined;
  snapLines: {
    vertical: SnapLine | undefined;
    horiztonal: SnapLine | undefined;
  };
} => {
  const source = gpsSource;
  const coordinates: Coordinate[] =
    source?.displayedCoordinates ?? source?.allCoordinates ?? [];
  const elevations = coordinates
    .map((c) => c.elevation)
    .filter((elevation): elevation is number => elevation !== undefined);

  const allZero = elevations.every((e) => e === 0);
  if (elevations.length === 0 || allZero) {
    return {
      elementUnderPointerLocation: undefined,
      snapLines: { vertical: undefined, horiztonal: undefined },
    };
  }
  // Draw elevation profile chart
  const chartWidth = rect.width;
  const chartHeight = rect.height;
  const minVisualHeight = 5; // Minimum height in pixels

  const maxElevation = Math.max(...elevations);
  const minElevation = Math.min(...elevations);
  const elevationRange = maxElevation - minElevation || 1;

  const chartX = rect.x;
  const chartY = rect.y;

  const numPoints = elevations.length;
  const sliceCount = Math.min(chartWidth, numPoints);
  const lineSpacing = chartWidth / sliceCount;

  const sampledElevations =
    numPoints > chartWidth
      ? Array.from(
          { length: chartWidth },
          (_, i) => elevations[Math.floor((i / chartWidth) * numPoints)]
        )
      : elevations;

  sampledElevations.forEach((elevation, index) => {
    const normalized = (elevation - minElevation) / elevationRange;
    const normalizedHeight =
      minVisualHeight + normalized * (chartHeight - minVisualHeight);

    const x = Math.round(chartX + index * lineSpacing);
    const width = Math.ceil(lineSpacing);
    ctx.fillStyle = color;
    ctx.fillRect(
      x,
      Math.round(chartY + chartHeight - normalizedHeight),
      width,
      Math.round(normalizedHeight)
    );
  });
  return {
    elementUnderPointerLocation: undefined,
    snapLines: { vertical: undefined, horiztonal: undefined },
  };
};
